import { selectProperStyles } from '@/components/modular-grid/utils';

import { WidgetTileGridProps } from './WidgetGrid';
import styles from './WidgetGrid.module.scss';

export const getWidgetBannerStyle = (size: WidgetTileGridProps['size']) => {
  return selectProperStyles(
    {
      small: styles.widgetBannerSmallForced,
      medium: styles.widgetBannerMediumForced,
      default: [styles.widgetBannerSmall, styles.widgetBannerMedium],
    },
    size
  );
};

export const getRowStyle = (size: WidgetTileGridProps['size']) => {
  return selectProperStyles(
    {
      small: styles.rowSmallForced,
      medium: styles.rowMediumForced,
      default: [styles.rowSmall, styles.rowMedium],
    },
    size
  );
};
